import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import historyMiddleware from './reducers/history/historyMiddleware';
import historyLifecycleMiddleware from './reducers/history/historyLifecycle';
import openRecipeFailureMiddleware from './reducers/workspace/openRecipeFailureMiddleware';
import logicMapperReducer from '../features/LogicMapper/logicMapperSlice';
import workspaceReducer from '../features/Workspace/workspaceSlice';
import interfaceReducer from '../features/interface/interfaceSlice';
import userReducer from './reducers/user/userSlice';
import widgetReducer from './reducers/widget/widgetSlice';
import websocketReducer from './reducers/websocket/websocketSlice';
import mainMenuReducer from '@components/mainMenu/mainMenuSlice';
import marketplaceReducer from '@components/layout/marketplace/marketplaceSlice';
import checkoutReducer from './reducers/checkout/checkoutSlice';
import snippetsReducer from './reducers/snippets/snippetsSlice';
import deploymentReducer from '../features/deployment/deploymentReducer';

export const store = configureStore({
  reducer: {
    workspace: workspaceReducer,
    logicMapper: logicMapperReducer,
    interface: interfaceReducer,
    marketplace: marketplaceReducer,
    mainMenu: mainMenuReducer,
    user: userReducer,
    widget: widgetReducer,
    websocket: websocketReducer,
    checkout: checkoutReducer,
    snippets: snippetsReducer,
    deployment: deploymentReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(historyLifecycleMiddleware, historyMiddleware, openRecipeFailureMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
